import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroVideo from "./images/uber.mp4";
import logo from "./images/cape1.png";

function KinKeeperLanding() {
  const navigate = useNavigate();
  const { t } = useTranslation("home");

  return (
    <div className="page-shell">
      <section className="page-panel kinkeeper-hub-page">
        <div className="page-content">
          <div className="kinkeeper-hub-layout">
            <div>
              <div className="hub-badge">{t("landing.badge")}</div>
              <h1 className="hub-title">{t("landing.title")}</h1>
              <p className="hub-subtitle">
                {t("landing.subtitle")}
              </p>

              <div className="hub-feature-grid">
                <div className="hub-feature-card">
                  <h3>{t("landing.feature1Title")}</h3>
                  <p>{t("landing.feature1Text")}</p>
                </div>
                <div className="hub-feature-card">
                  <h3>{t("landing.feature2Title")}</h3>
                  <p>{t("landing.feature2Text")}</p>
                </div>
                <div className="hub-feature-card">
                  <h3>{t("landing.feature3Title")}</h3>
                  <p>{t("landing.feature3Text")}</p>
                </div>
              </div>

              <div className="hero-actions">
                <button className="button" onClick={() => navigate("/login")}>
                  {t("landing.actions.login")}
                </button>
                <button className="warm-button" onClick={() => navigate("/register")}>
                  {t("landing.actions.register")}
                </button>
                <button className="ghost-button" onClick={() => navigate("/elders")}>
                  {t("landing.actions.viewElders")}
                </button>
              </div>
            </div>

            <div className="hub-media-stack">
              <div className="hub-brand-card">
                <img src={logo} alt={t("landing.brandAlt")} className="selector-brand-logo" />
                <div>
                  <div className="media-label">{t("landing.brandLabel")}</div>
                  <h3>{t("landing.brandTitle")}</h3>
                  <p>{t("landing.brandText")}</p>
                </div>
              </div>

              <div className="hero-card hero-visual media-card">
                <div className="media-label">{t("landing.mediaLabel")}</div>
                <video className="hero-video" autoPlay muted loop controls>
                  <source src={heroVideo} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default KinKeeperLanding;
